import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AsyncData } from '@model/common';
import { DataEnvelope } from '@model/iceberg';
import { MyBookingDocument, MyBookingDocuments } from '@model/mmb';
import { MyBookingDocumentsApi } from '@model/iceberg/service/mmb/my-booking-documents-api';

export enum MyBookingDocumentsActions {
  SLICE_NAME = '@MMBDOCUMENTS',
  FETCH_BOOKING_DOCUMENTS = '@MMBDOCUMENTS/fetchBookingDocuments'
}

export type MMBDocumentsState = Array<MyBookingDocument>;

export type MyBookingDocumentsResponse = DataEnvelope<MyBookingDocuments>;

export interface MyBookingDocumentsRequestPayload {
  bookingId: number;
  loginToken: string;
}

export const INITIAL_BOOKING_DOCUMENTS_STATE: AsyncData<Array<MyBookingDocument>> = {
  data: [] as any,
  loading: false,
  error: null
};

export const fetchBookingDocuments = createAsyncThunk(
  MyBookingDocumentsActions.FETCH_BOOKING_DOCUMENTS,
  async ({ bookingId, loginToken }: MyBookingDocumentsRequestPayload, { rejectWithValue }) => {
    const api: MyBookingDocumentsApi = new MyBookingDocumentsApi();

    try {
      const response: MyBookingDocumentsResponse = await api.getBookingDocuments({ bookingId, loginToken });
      return response.data.documents;
    } catch (error: any) {
      if (error.response) {
        return rejectWithValue({ status: error.response.status, data: error.response.data });
      }
      return rejectWithValue({ message: error.message });
    }
  }
);

const mmbDocumentsSlice = createSlice({
  name: MyBookingDocumentsActions.SLICE_NAME,
  initialState: INITIAL_BOOKING_DOCUMENTS_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookingDocuments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBookingDocuments.fulfilled, (state, action) => {
        state.data = action.payload;
        state.error = null;
        state.loading = false;
      })
      .addCase(fetchBookingDocuments.rejected, (state, action) => {
        state.data = INITIAL_BOOKING_DOCUMENTS_STATE.data;
        state.error = action.payload;
        state.loading = false;
      });
  }
});

export const mmbDocumentsReducer = mmbDocumentsSlice.reducer;
